import React, { createContext, useContext, useState, useCallback, useRef } from 'react'
import { AuthContext } from "./AuthContext";
import axios from "axios";
import baseurl from "../services/empresa/baseurl";
import Cookies from 'js-cookie'
import { ApiContext } from './ApiContext';
import { Form } from 'react-bootstrap';

export const ServicoContext = createContext()

export const ServicoContextProvider = ({ children }) => {

    const { setAuth } = useContext(AuthContext)
    const { staticKey } = useContext(ApiContext)
    const [Error, setError] = useState("")
    const [Success, setSuccess] = useState("")
    const [Loading, setLoading] = useState(false)
    const [openModal, setOpenModal] = useState(false);
    const [CadastroGrupo, setCadastroGrupo] = useState("")
    const [Grupos, setGrupos] = useState("")
    const [GruposConsulta, setGruposConsulta] = useState("")
    const [EdicaoGrupo, setEdicaoGrupo] = useState("")
    const [GrupoAtualKey, setGrupoAtualKey] = useState("")
    const [modalEditarGrupo, setModalEditarGrupo] = useState(false);
    const [modalExcluirGrupo, setModalExcluirGrupo] = useState(false);
    const [CadastroSubgrupo, setCadastroSubgrupo] = useState("")
    const [Subgrupos, setSubgrupos] = useState("")
    const [SubgruposConsulta, setSubgruposConsulta] = useState("")
    const [EdicaoSubgrupo, setEdicaoSubgrupo] = useState("")
    const [SubgrupoAtualKey, setSubgrupoAtualKey] = useState("")
    const [modalEditarSubgrupo, setModalEditarSubgrupo] = useState(false);
    const [modalExcluirSubgrupo, setModalExcluirSubgrupo] = useState(false);
    const [CadastroItem, setCadastroItem] = useState("");
    const [Itens, setItens] = useState("");
    const [ItensConsulta, setItensConsulta] = useState("");
    const [EdicaoItem, setEdicaoItem] = useState("");
    const [ItemAtualKey, setItemAtualKey] = useState("");
    const [modalEditarItem, setModalEditarItem] = useState(false);
    const [modalExcluirItem, setModalExcluirItem] = useState(false);
    const [CadastroPeriodicidade, setCadastroPeriodicidade] = useState("");
    const [Periodicidades, setPeriodicidades] = useState("");
    const [PeriodicidadesConsulta, setPeriodicidadesConsulta] = useState("");
    const [EdicaoPeriodicidade, setEdicaoPeriodicidade] = useState("");
    const [PeriodicidadeAtualKey, setPeriodicidadeAtualKey] = useState("");
    const [modalEditarPeriodicidade, setModalEditarPeriodicidade] = useState(false);
    const [modalExcluirPeriodicidade, setModalExcluirPeriodicidade] = useState(false);
    const [CadastroSLA, setCadastroSLA] = useState("");
    const [SLAs, setSLAs] = useState("");
    const [SLAsConsulta, setSLAsConsulta] = useState("");
    const [EdicaoSLA, setEdicaoSLA] = useState("");
    const [SLAAtualKey, setSLAAtualKey] = useState("");
    const [modalEditarSLA, setModalEditarSLA] = useState(false);
    const [modalExcluirSLA, setModalExcluirSLA] = useState(false);
    const [CadastroMetodo, setCadastroMetodo] = useState("");
    const [Metodos, setMetodos] = useState("");
    const [MetodosConsulta, setMetodosConsulta] = useState("");
    const [EdicaoMetodo, setEdicaoMetodo] = useState("");
    const [MetodoAtualKey, setMetodoAtualKey] = useState("");
    const [modalEditarMetodo, setModalEditarMetodo] = useState(false);
    const [modalExcluirMetodo, setModalExcluirMetodo] = useState(false);
    const [CadastroCobertura, setCadastroCobertura] = useState("");
    const [Coberturas, setCoberturas] = useState("");
    const [CoberturasConsulta, setCoberturasConsulta] = useState("");
    const [EdicaoCobertura, setEdicaoCobertura] = useState("");
    const [CoberturaAtualKey, setCoberturaAtualKey] = useState("");
    const [modalEditarCobertura, setModalEditarCobertura] = useState(false);
    const [modalExcluirCobertura, setModalExcluirCobertura] = useState(false);
    const [CadastroTipoServico, setCadastroTipoServico] = useState("");
    const [TiposServico, setTiposServico] = useState("");
    const [TiposServicoConsulta, setTiposServicoConsulta] = useState("");
    const [EdicaoTipoServico, setEdicaoTipoServico] = useState("");
    const [TipoServicoAtualKey, setTipoServicoAtualKey] = useState("");
    const [modalEditarTipoServico, setModalEditarTipoServico] = useState(false);
    const [modalExcluirTipoServico, setModalExcluirTipoServico] = useState(false);
    const [CadastroPratica, setCadastroPratica] = useState("");
    const [Praticas, setPraticas] = useState("");
    const [PraticasConsulta, setPraticasConsulta] = useState("");
    const [EdicaoPratica, setEdicaoPratica] = useState("");
    const [PraticaAtualKey, setPraticaAtualKey] = useState("");
    const [modalEditarPratica, setModalEditarPratica] = useState(false);
    const [modalExcluirPratica, setModalExcluirPratica] = useState(false);
    const [CadastroOrganizacao, setCadastroOrganizacao] = useState("");
    const [Organizacoes, setOrganizacoes] = useState("");
    const [OrganizacoesConsulta, setOrganizacoesConsulta] = useState("");
    const [EdicaoOrganizacao, setEdicaoOrganizacao] = useState("");
    const [OrganizacaoAtualKey, setOrganizacaoAtualKey] = useState("");
    const [modalEditarOrganizacao, setModalEditarOrganizacao] = useState(false);
    const [modalExcluirOrganizacao, setModalExcluirOrganizacao] = useState(false);
    const [CadastroLocalidade, setCadastroLocalidade] = useState("");
    const [Localidades, setLocalidades] = useState("");
    const [LocalidadesConsulta, setLocalidadesConsulta] = useState("");
    const [EdicaoLocalidade, setEdicaoLocalidade] = useState("");
    const [LocalidadeAtualKey, setLocalidadeAtualKey] = useState("");
    const [modalEditarLocalidade, setModalEditarLocalidade] = useState(false);
    const [modalExcluirLocalidade, setModalExcluirLocalidade] = useState(false);
    const [CadastroFornecedor, setCadastroFornecedor] = useState("");
    const [Fornecedores, setFornecedores] = useState("");
    const [FornecedoresConsulta, setFornecedoresConsulta] = useState("");
    const [EdicaoFornecedor, setEdicaoFornecedor] = useState("");
    const [FornecedorAtualKey, setFornecedorAtualKey] = useState("");
    const [modalEditarFornecedor, setModalEditarFornecedor] = useState(false);
    const [modalExcluirFornecedor, setModalExcluirFornecedor] = useState(false);
    const [CadastroServico, setCadastroServico] = useState("");
    const [Servicos, setServicos] = useState("");
    const [ServicosConsulta, setServicosConsulta] = useState("");
    const [EdicaoServico, setEdicaoServico] = useState("");
    const [ServicoAtualKey, setServicoAtualKey] = useState("");
    const [modalEditarServico, setModalEditarServico] = useState(false);
    const [modalExcluirServico, setModalExcluirServico] = useState(false);
    const [ServicoSubgrupo, setServicoSubgrupo] = useState("");
    const [ServicoItem, setServicoItem] = useState("");
    const [ServicoLocalidade, setServicoLocalidade] = useState("");
    const [AddFile, setAddFile] = useState("");
    const [File, setFile] = useState("");
    const [FormAnexo, setFormAnexo] = useState("");
    const [AddFileServico, setAddFileServico] = useState("");
    const [FileServico, setFileServico] = useState("");
    const [FormAnexoServico, setFormAnexoServico] = useState([]);
    const [AddLink, setAddLink] = useState("");
    const [Link, setLink] = useState([]);
    const [FormLink, setFormLink] = useState("");
    const [ServicoOrganizacao, setServicoOrganizacao] = useState("");
    const [ServicoArea, setServicoArea] = useState("");
    const [ServicoPratica, setServicoPratica] = useState("");
    const [ServicoFornecedor, setServicoFornecedor] = useState("");
    const [ServicoExecutor, setServicoExecutor] = useState("");
    const [ServicoLocalidadeEditar, setServicoLocalidadeEditar] = useState("");
    const [ServicoSistema, setServicoSistema] = useState("");
    const [ServicoObter, setServicoObter] = useState("");

    const linkRef = useRef(null);
    const descricaoRef = useRef(null);

    const EmpresaKey = staticKey == "" ? Cookies.get("Key") : staticKey;

    const CadastrarGrupo = async (event, currentPage) => {
        setLoading(true)
        event.preventDefault();
        const token = Cookies.get("Token");
        if (CadastroGrupo === "") {
            setLoading(false)
            setError("Formulário vazio.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        if (typeof CadastroGrupo.descricao === "undefined" || CadastroGrupo.descricao === "") {
            setLoading(false)
            setError("Nome não informado");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        const data = {
            empresaKey: EmpresaKey,
            descricao: CadastroGrupo.descricao,
            ativo: true,
            idExterno: CadastroGrupo.idExterno
        };
        return axios({
            url: baseurl + "Grupo/Adicionar",
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                ListaGrupoConsulta(currentPage, 10)
                setSuccess("Grupo cadastrado com sucesso!");
                setCadastroGrupo({
                    descricao: "",
                })
                setOpenModal(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setLoading(false)
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setError(error.response.data)
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject(error);
                setLoading(false)
            });
    }

    const ListaGrupo = useCallback(async () => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Grupo/Listar?empresaKey=" + EmpresaKey + "&somenteAtivas=S",
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setLoading(false)
                setGrupos(response.data);
            })
            .catch((error) => {
                setLoading(false)
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    })

    const [totalRegistrosGrupo, setTotalRegistrosGrupo] = useState(0);

    const ListaGrupoConsulta = useCallback(async (posicao, qtd) => {
        try {
            const token = Cookies.get("Token");
            const response = await axios({
                url: `${baseurl}Grupo/ListarConsulta?empresaKey=${EmpresaKey}&posicao=${posicao}&quantidade=${qtd}&somenteAtivas=N`,
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });
            setLoading(false);
            const user = eval(response.data.data);
            const arrayArea = user.map((e) => ({
                descricao: e.descricao,
                key: e.key,
                ativo: e.ativo,
                id: e.id,
                idExterno: e.idExterno
            }));
            setGruposConsulta(prevAreas => {
                const isEqual = JSON.stringify(prevAreas) === JSON.stringify(arrayArea);
                return isEqual ? prevAreas : arrayArea;
            });
            setTotalRegistrosGrupo(response.data.totalRegistros);
        } catch (error) {
            setLoading(false);
            if (error.response.status === 401) {
                setError(`Sua sessão expirou, faça login novamente`)
                setTimeout(() => {
                    setError("");
                }, 3000);
                setAuth(false)
                return
            }
            error.response.data.map((er) => {
                setError(`${er.campo}: ${er.mensagem}`)
            })
            setTimeout(() => {
                setError("");
            }, 3000);
            return Promise.reject(error);
        }
    });

    const [filtroGrupo, setFiltroGrupo] = useState([]);
    const [totalRegistrosFiltroGrupo, setTotalRegistrosFiltroGrupo] = useState(0);

    const ListaFiltroGrupo = useCallback(async (filtro, posicao, quantidade) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Grupo/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setFiltroGrupo(response.data.data);
                setTotalRegistrosFiltroGrupo(response.data.totalRegistros);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const EditarGrupo = async (currentPage) => {
        setLoading(true)
        const token = Cookies.get("Token");
        const data = {
            empresaKey: EmpresaKey,
            descricao: EdicaoGrupo.descricao,
            ativo: EdicaoGrupo.ativo,
            idExterno: EdicaoGrupo.idExterno,
            empresaKey: EmpresaKey
        };
        return axios({
            url: baseurl + "Grupo/Alterar?key=" + GrupoAtualKey,
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                ListaGrupoConsulta(currentPage, 10)
                setSuccess("Grupo editado com sucesso!");
                setModalEditarGrupo(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setLoading(false)
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                setLoading(false)
                return Promise.reject();
            });
    }

    const InativarGrupo = async (key, status) => {
        setLoading(true)
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Grupo/Ativo?key=" + key + "&status=" + status,
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setGruposConsulta(prev =>
                    prev.map(item =>
                        item.key === key ? { ...item, ativo: status } : item
                    )
                );
                setSuccess("Grupo ativado/inativado com sucesso!");
                setModalEditarGrupo(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setLoading(false)
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                setLoading(false)
                return Promise.reject();
            });
    }

    const ExcluirGrupo = async (key, currentPage) => {
        setLoading(true)
        const token = Cookies.get("Token")
        return axios({
            url: baseurl + "Grupo/Deletar?key=" + key,
            method: "DELETE",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setLoading(false)
                ListaGrupoConsulta(currentPage, 10)
                setSuccess("Grupo excluído com sucesso!")
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setModalExcluirGrupo(false)
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false)
                    return
                }
                setLoading(false)
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject(error)
            })
    }

    const CadastrarSubgrupo = async (event, currentPage) => {
        setLoading(true)
        event.preventDefault();
        const token = Cookies.get("Token");
        if (CadastroSubgrupo === "") {
            setLoading(false)
            setError("Formulário vazio.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        if (typeof CadastroSubgrupo.descricao === "undefined" || CadastroSubgrupo.descricao === "") {
            setError("Nome não informado");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        const data = {
            empresaKey: EmpresaKey,
            descricao: CadastroSubgrupo.descricao,
            grupoKey: CadastroSubgrupo.grupoKey,
            ativo: true,
            idExterno: CadastroSubgrupo.idExterno
        };
        return axios({
            url: baseurl + "Subgrupo/Adicionar",
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                ListaSubgrupoConsulta(currentPage, 10);
                setSuccess("Subgrupo cadastrado com sucesso!");
                setCadastroSubgrupo({ descricao: "" });
                setOpenModal(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setLoading(false)
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                setLoading(false)
                return Promise.reject(error);
            });
    };

    const ListaSubgrupo = useCallback(async () => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Subgrupo/Listar?empresaKey=" + EmpresaKey + "&somenteAtivas=S",
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setLoading(false)
                setSubgrupos(response.data);
            })
            .catch((error) => {
                setLoading(false)
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    })

    const [totalRegistrosSubgrupo, setTotalRegistrosSubgrupo] = useState(0);

    const ListaSubgrupoConsulta = useCallback(async (posicao, qtd) => {
        try {
            const token = Cookies.get("Token");
            const response = await axios({
                url: `${baseurl}Subgrupo/ListarConsulta?empresaKey=${EmpresaKey}&posicao=${posicao}&quantidade=${qtd}&somenteAtivas=N`,
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });
            setLoading(false);
            const user = eval(response.data.data);
            const arrayArea = user.map((e) => ({
                descricao: e.descricao,
                key: e.key,
                grupo: e.grupo,
                ativo: e.ativo,
                id: e.id,
                idExterno: e.idExterno
            }));
            setSubgruposConsulta(prevAreas => {
                const isEqual = JSON.stringify(prevAreas) === JSON.stringify(arrayArea);
                return isEqual ? prevAreas : arrayArea;
            });
            setTotalRegistrosSubgrupo(response.data.totalRegistros);
        } catch (error) {
            setLoading(false);
            if (error.response.status === 401) {
                setError(`Sua sessão expirou, faça login novamente`)
                setTimeout(() => {
                    setError("");
                }, 3000);
                setAuth(false)
                return
            }
            error.response.data.map((er) => {
                setError(`${er.campo}: ${er.mensagem}`)
            })
            setTimeout(() => {
                setError("");
            }, 3000);
            return Promise.reject(error);
        }
    });

    const [filtroSubgrupo, setFiltroSubgrupo] = useState([]);
    const [totalRegistrosFiltroSubgrupo, setTotalRegistrosFiltroSubgrupo] = useState(0);

    const ListaFiltroSubgrupo = useCallback(async (filtro, posicao, quantidade) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Subgrupo/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setFiltroSubgrupo(response.data.data);
                setTotalRegistrosFiltroSubgrupo(response.data.totalRegistros);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const EditarSubgrupo = async (grupoKey, currentPage) => {
        setLoading(true)
        const token = Cookies.get("Token");
        const data = {
            empresaKey: EmpresaKey,
            descricao: EdicaoSubgrupo.descricao,
            grupoKey: grupoKey,
            ativo: EdicaoSubgrupo.ativo,
            idExterno: EdicaoSubgrupo.idExterno
        };
        return axios({
            url: baseurl + "Subgrupo/Alterar?key=" + SubgrupoAtualKey,
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                ListaSubgrupoConsulta(currentPage, 10);
                setSuccess("Subgrupo editado com sucesso!");
                setModalEditarSubgrupo(false);
                setLoading(false)
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                setLoading(false)
                return Promise.reject();
            });
    };

    const InativarSubgrupo = async (key, status) => {
        setLoading(true)
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Subgrupo/Ativo?key=" + key + "&status=" + status,
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setSubgruposConsulta(prev =>
                    prev.map(item =>
                        item.key === key ? { ...item, ativo: status } : item
                    )
                );
                setSuccess("Subgrupo ativado/inativado com sucesso!");
                setModalEditarSubgrupo(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setLoading(false)
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                setLoading(false)
                return Promise.reject();
            });
    };

    const ExcluirSubgrupo = async (key, currentPage) => {
        setLoading(true)
        const token = Cookies.get("Token")
        return axios({
            url: baseurl + "Subgrupo/Deletar?key=" + key,
            method: "DELETE",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setLoading(false)
                ListaSubgrupoConsulta(currentPage, 10)
                setSuccess("Subgrupo excluído com sucesso!")
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setModalExcluirSubgrupo(false)
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false)
                    return
                }
                setLoading(false)
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject(error)
            })
    }

    const CadastrarItem = async (event, currentPage) => {
        setLoading(true)
        event.preventDefault();
        const token = Cookies.get("Token");
        if (CadastroItem === "") {
            setLoading(false);
            setError("Formulário vazio.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        if (typeof CadastroItem.descricao === "undefined" || CadastroItem.descricao === "") {
            setLoading(false);
            setError("Nome não informado");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        const data = {
            empresaKey: EmpresaKey,
            descricao: CadastroItem.descricao,
            subGrupoKey: CadastroItem.subGrupoKey,
            ativo: true,
            idExterno: CadastroItem.idExterno
        };
        return axios({
            url: baseurl + "Item/Adicionar",
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                ListaItemConsulta(currentPage, 10);
                setSuccess("Item cadastrado com sucesso!");
                setCadastroItem({ descricao: "" });
                setOpenModal(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setLoading(false)
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                setLoading(false)
                return Promise.reject(error);
            });
    };

    const ListaItem = useCallback(async () => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Item/Listar?empresaKey=" + EmpresaKey + "&somenteAtivas=S",
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setItens(response.data);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const [totalRegistrosItem, setTotalRegistrosItem] = useState(0);

    const ListaItemConsulta = useCallback(async (posicao, qtd) => {
        try {
            const token = Cookies.get("Token");
            const response = await axios({
                url: `${baseurl}Item/ListarConsulta?empresaKey=${EmpresaKey}&posicao=${posicao}&quantidade=${qtd}&somenteAtivas=N`,
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });
            setLoading(false);
            const user = eval(response.data.data);
            const arrayArea = user.map((e) => ({
                descricao: e.descricao,
                key: e.key,
                subGrupo: e.subGrupo,
                ativo: e.ativo,
                id: e.id,
                idExterno: e.idExterno
            }));
            setItensConsulta((prevAreas) => {
                const isEqual = JSON.stringify(prevAreas) === JSON.stringify(arrayArea);
                return isEqual ? prevAreas : arrayArea;
            });
            setTotalRegistrosItem(response.data.totalRegistros);
        } catch (error) {
            setLoading(false);
            if (error.response.status === 401) {
                setError(`Sua sessão expirou, faça login novamente`);
                setTimeout(() => {
                    setError("");
                }, 3000);
                setAuth(false);
                return;
            }
            error.response.data.map((er) => {
                setError(`${er.campo}: ${er.mensagem}`);
            });
            setTimeout(() => {
                setError("");
            }, 3000);
            return Promise.reject(error);
        }
    });

    const [filtroItem, setFiltroItem] = useState([]);
    const [totalRegistrosFiltroItem, setTotalRegistrosFiltroItem] = useState(0);

    const ListaFiltroItem = useCallback(async (filtro, posicao, quantidade) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Item/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setFiltroItem(response.data.data);
                setTotalRegistrosFiltroItem(response.data.totalRegistros);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const EditarItem = async (subGrupoKey, currentPage) => {
        setLoading(true)
        const token = Cookies.get("Token");
        const data = {
            empresaKey: EmpresaKey,
            descricao: EdicaoItem.descricao,
            subGrupoKey: subGrupoKey,
            ativo: EdicaoItem.ativo,
            idExterno: EdicaoItem.idExterno,
            empresaKey: EmpresaKey
        };
        return axios({
            url: baseurl + "Item/Alterar?key=" + ItemAtualKey,
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                ListaItemConsulta(currentPage, 10);
                setSuccess("Item editado com sucesso!");
                setModalEditarItem(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setLoading(false)
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                setLoading(false)
                return Promise.reject();
            });
    };

    const InativarItem = async (key, status) => {
        setLoading(true)
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Item/Ativo?key=" + key + "&status=" + status,
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setItensConsulta(prev =>
                    prev.map(item =>
                        item.key === key ? { ...item, ativo: status } : item
                    )
                );
                setSuccess("Item ativado/inativado com sucesso!");
                setModalEditarItem(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setLoading(false)
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                setLoading(false)
                return Promise.reject();
            });
    };

    const ExcluirItem = async (key, currentPage) => {
        setLoading(true);
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Item/Deletar?key=" + key,
            method: "DELETE",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setLoading(false);
                ListaItemConsulta(currentPage, 10);
                setSuccess("Item excluído com sucesso!");
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setModalExcluirItem(false);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false);
                    return;
                }
                setLoading(false);
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject(error);
            });
    };

    const CadastrarPeriodicidade = async (event, currentPage) => {
        setLoading(true)
        event.preventDefault();
        const token = Cookies.get("Token");
        if (CadastroPeriodicidade === "") {
            setLoading(false);
            setError("Formulário vazio.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        if (typeof CadastroPeriodicidade.nome === "undefined" || CadastroPeriodicidade.nome === "") {
            setLoading(false);
            setError("Nome não informado");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        const data = {
            empresaKey: EmpresaKey,
            nome: CadastroPeriodicidade.nome,
            descricao: CadastroPeriodicidade.descricao,
            ativo: true,
            idExterno: CadastroPeriodicidade.idExterno
        };
        return axios({
            url: baseurl + "Periodicidade/Adicionar",
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                ListaPeriodicidadeConsulta(currentPage, 10);
                setSuccess("Periodicidade cadastrada com sucesso!");
                setCadastroPeriodicidade({ descricao: "", nome: "" });
                setOpenModal(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setLoading(false);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                setLoading(false);
                return Promise.reject(error);
            });
    };

    const ListaPeriodicidade = useCallback(async () => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Periodicidade/Listar?empresaKey=" + EmpresaKey + "&somenteAtivas=S",
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setPeriodicidades(response.data);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const [totalRegistrosPeriodicidade, setTotalRegistrosPeriodicidade] = useState(0);

    const ListaPeriodicidadeConsulta = useCallback(async (posicao, qtd) => {
        try {
            const token = Cookies.get("Token");
            const response = await axios({
                url: `${baseurl}Periodicidade/ListarConsulta?empresaKey=${EmpresaKey}&posicao=${posicao}&quantidade=${qtd}&somenteAtivas=N`,
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });
            setLoading(false);
            const user = eval(response.data.data);
            const arrayArea = user.map((e) => ({
                nome: e.nome,
                descricao: e.descricao,
                key: e.key,
                ativo: e.ativo,
                id: e.id,
                idExterno: e.idExterno
            }));
            setPeriodicidadesConsulta((prevAreas) => {
                const isEqual = JSON.stringify(prevAreas) === JSON.stringify(arrayArea);
                return isEqual ? prevAreas : arrayArea;
            });
            setTotalRegistrosPeriodicidade(response.data.totalRegistros);
        } catch (error) {
            setLoading(false);
            if (error.response.status === 401) {
                setError(`Sua sessão expirou, faça login novamente`);
                setTimeout(() => {
                    setError("");
                }, 3000);
                setAuth(false);
                return;
            }
            error.response.data.map((er) => {
                setError(`${er.campo}: ${er.mensagem}`);
            });
            setTimeout(() => {
                setError("");
            }, 3000);
            return Promise.reject(error);
        }
    });

    const [filtroPeriodicidade, setFiltroPeriodicidade] = useState([]);
    const [totalRegistrosFiltroPeriodicidade, setTotalRegistrosFiltroPeriodicidade] = useState(0);

    const ListaFiltroPeriodicidade = useCallback(async (filtro, posicao, quantidade) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Periodicidade/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setFiltroPeriodicidade(response.data.data);
                setTotalRegistrosFiltroPeriodicidade(response.data.totalRegistros);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const EditarPeriodicidade = async (currentPage) => {
        setLoading(true)
        const token = Cookies.get("Token");
        const data = {
            empresaKey: EmpresaKey,
            nome: EdicaoPeriodicidade.nome,
            descricao: EdicaoPeriodicidade.descricao,
            ativo: EdicaoPeriodicidade.ativo,
            idExterno: EdicaoPeriodicidade.idExterno,
            empresaKey: EmpresaKey
        };
        return axios({
            url: baseurl + "Periodicidade/Alterar?key=" + PeriodicidadeAtualKey,
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                ListaPeriodicidadeConsulta(currentPage, 10);
                setSuccess("Periodicidade editada com sucesso!");
                setModalEditarPeriodicidade(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setLoading(false);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                setLoading(false);
                return Promise.reject();
            });
    };

    const InativarPeriodicidade = async (key, status) => {
        setLoading(true)
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Periodicidade/Ativo?key=" + key + "&status=" + status,
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setPeriodicidadesConsulta(prev =>
                    prev.map(item =>
                        item.key === key ? { ...item, ativo: status } : item
                    )
                );
                setSuccess("Periodicidade ativada/inativada com sucesso!");
                setModalEditarPeriodicidade(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setLoading(false);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                setLoading(false);
                return Promise.reject();
            });
    };

    const ExcluirPeriodicidade = async (key, currentPage) => {
        setLoading(true);
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Periodicidade/Deletar?key=" + key,
            method: "DELETE",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setLoading(false);
                ListaPeriodicidadeConsulta(currentPage, 10);
                setSuccess("Periodicidade excluída com sucesso!");
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setModalExcluirPeriodicidade(false);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false);
                    return;
                }
                setLoading(false);
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject(error);
            });
    };

    const CadastrarSLA = async (event, currentPage) => {
        event.preventDefault();
        const token = Cookies.get("Token");
        if (CadastroSLA === "") {
            setLoading(false);
            setError("Formulário vazio.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        if (typeof CadastroSLA.nome === "undefined" || CadastroSLA.nome === "") {
            setLoading(false);
            setError("Nome não informado");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        const data = {
            empresaKey: EmpresaKey,
            nome: CadastroSLA.nome,
            descricao: CadastroSLA.descricao,
            ativo: true,
            idExterno: CadastroSLA.idExterno
        };
        return axios({
            url: baseurl + "SLA/Adicionar",
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                ListaSLAConsulta(currentPage, 10);
                setSuccess("SLA cadastrado com sucesso!");
                setCadastroSLA({ descricao: "", nome: "" });
                setOpenModal(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject(error);
            });
    };

    const ListaSLA = useCallback(async () => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "SLA/Listar?empresaKey=" + EmpresaKey + "&somenteAtivas=S",
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setSLAs(response.data);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const [totalRegistrosSLA, setTotalRegistrosSLA] = useState(0);

    const ListaSLAConsulta = useCallback(async (posicao, qtd) => {
        try {
            const token = Cookies.get("Token");
            const response = await axios({
                url: `${baseurl}SLA/ListarConsulta?empresaKey=${EmpresaKey}&posicao=${posicao}&quantidade=${qtd}&somenteAtivas=N`,
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });
            setLoading(false);
            const user = eval(response.data.data);
            const arrayArea = user.map((e) => ({
                descricao: e.descricao,
                nome: e.nome,
                key: e.key,
                ativo: e.ativo,
                id: e.id,
                idExterno: e.idExterno
            }));
            setSLAsConsulta((prevAreas) => {
                const isEqual = JSON.stringify(prevAreas) === JSON.stringify(arrayArea);
                return isEqual ? prevAreas : arrayArea;
            });
            setTotalRegistrosSLA(response.data.totalRegistros);
        } catch (error) {
            setLoading(false);
            if (error.response.status === 401) {
                setError(`Sua sessão expirou, faça login novamente`);
                setTimeout(() => {
                    setError("");
                }, 3000);
                setAuth(false);
                return;
            }
            error.response.data.map((er) => {
                setError(`${er.campo}: ${er.mensagem}`);
            });
            setTimeout(() => {
                setError("");
            }, 3000);
            return Promise.reject(error);
        }
    });

    const [filtroSLA, setFiltroSLA] = useState([]);
    const [totalRegistrosFiltroSLA, setTotalRegistrosFiltroSLA] = useState(0);

    const ListaFiltroSLA = useCallback(async (filtro, posicao, quantidade) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "SLA/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setFiltroSLA(response.data.data);
                setTotalRegistrosFiltroSLA(response.data.totalRegistros);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const EditarSLA = async (currentPage) => {
        const token = Cookies.get("Token");
        const data = {
            empresaKey: EmpresaKey,
            nome: EdicaoSLA.nome,
            descricao: EdicaoSLA.descricao,
            ativo: EdicaoSLA.ativo,
            idExterno: EdicaoSLA.idExterno
        };
        return axios({
            url: baseurl + "SLA/Alterar?key=" + SLAAtualKey,
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                ListaSLAConsulta(currentPage, 10);
                setSuccess("SLA editado com sucesso!");
                setModalEditarSLA(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    };

    const InativarSLA = async (key, status) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "SLA/Ativo?key=" + key + "&status=" + status,
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setSLAsConsulta(prev =>
                    prev.map(item =>
                        item.key === key ? { ...item, ativo: status } : item
                    )
                );
                setSuccess("SLA ativado/inativado com sucesso!");
                setModalEditarSLA(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    };

    const ExcluirSLA = async (key, currentPage) => {
        setLoading(true);
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "SLA/Deletar?key=" + key,
            method: "DELETE",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setLoading(false);
                ListaSLAConsulta(currentPage, 10);
                setSuccess("SLA excluído com sucesso!");
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setModalExcluirSLA(false);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false);
                    return;
                }
                setLoading(false);
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject(error);
            });
    };

    const CadastrarMetodo = async (event, currentPage) => {
        event.preventDefault();
        const token = Cookies.get("Token");
        if (CadastroMetodo === "") {
            setLoading(false);
            setError("Formulário vazio.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        if (typeof CadastroMetodo.nome === "undefined" || CadastroMetodo.nome === "") {
            setLoading(false);
            setError("Nome não informado");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        const data = {
            empresaKey: EmpresaKey,
            nome: CadastroMetodo.nome,
            descricao: CadastroMetodo.descricao,
            ativo: true,
            idExterno: CadastroMetodo.idExterno
        };
        return axios({
            url: baseurl + "MetodoSolicitacao/Adicionar",
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                ListaMetodoConsulta(currentPage, 10);
                setSuccess("Método de Solicitação cadastrado com sucesso!");
                setCadastroMetodo({ descricao: "" });
                setOpenModal(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject(error);
            });
    };

    const ListaMetodo = useCallback(async () => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "MetodoSolicitacao/Listar?empresaKey=" + EmpresaKey + "&somenteAtivas=S",
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setMetodos(response.data);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const [totalRegistrosMetodo, setTotalRegistrosMetodo] = useState(0);

    const ListaMetodoConsulta = useCallback(async (posicao, qtd) => {
        try {
            const token = Cookies.get("Token");
            const response = await axios({
                url: `${baseurl}MetodoSolicitacao/ListarConsulta?empresaKey=${EmpresaKey}&posicao=${posicao}&quantidade=${qtd}&somenteAtivas=N`,
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });
            setLoading(false);
            const user = eval(response.data.data);
            const arrayArea = user.map((e) => ({
                nome: e.nome,
                descricao: e.descricao,
                key: e.key,
                ativo: e.ativo,
                id: e.id,
                idExterno: e.idExterno
            }));
            setMetodosConsulta((prevAreas) => {
                const isEqual = JSON.stringify(prevAreas) === JSON.stringify(arrayArea);
                return isEqual ? prevAreas : arrayArea;
            });
            setTotalRegistrosMetodo(response.data.totalRegistros);
        } catch (error) {
            setLoading(false);
            if (error.response.status === 401) {
                setError(`Sua sessão expirou, faça login novamente`);
                setTimeout(() => {
                    setError("");
                }, 3000);
                setAuth(false);
                return;
            }
            error.response.data.map((er) => {
                setError(`${er.campo}: ${er.mensagem}`);
            });
            setTimeout(() => {
                setError("");
            }, 3000);
            return Promise.reject(error);
        }
    });

    const [filtroMetodo, setFiltroMetodo] = useState([]);
    const [totalRegistrosFiltroMetodo, setTotalRegistrosFiltroMetodo] = useState(0);

    const ListaFiltroMetodo = useCallback(async (filtro, posicao, quantidade) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "MetodoSolicitacao/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setFiltroMetodo(response.data.data);
                setTotalRegistrosFiltroMetodo(response.data.totalRegistros);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const EditarMetodo = async (currentPage) => {
        const token = Cookies.get("Token");
        const data = {
            empresaKey: EmpresaKey,
            nome: EdicaoMetodo.nome,
            descricao: EdicaoMetodo.descricao,
            ativo: EdicaoMetodo.ativo,
            idExterno: EdicaoMetodo.idExterno,
            empresaKey: EmpresaKey
        };
        return axios({
            url: baseurl + "MetodoSolicitacao/Alterar?key=" + MetodoAtualKey,
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                ListaMetodoConsulta(currentPage, 10);
                setSuccess("Método de Solicitação editado com sucesso!");
                setModalEditarMetodo(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    };

    const InativarMetodo = async (key, status) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "MetodoSolicitacao/Ativo?key=" + key + "&status=" + status,
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setMetodosConsulta(prev =>
                    prev.map(item =>
                        item.key === key ? { ...item, ativo: status } : item
                    )
                );
                setSuccess("Método de Solicitação ativado/inativado com sucesso!");
                setModalEditarMetodo(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    };

    const ExcluirMetodo = async (key, currentPage) => {
        setLoading(true);
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "MetodoSolicitacao/Deletar?key=" + key,
            method: "DELETE",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setLoading(false);
                ListaMetodoConsulta(currentPage, 10);
                setSuccess("Método de Solicitação excluído com sucesso!");
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setModalExcluirMetodo(false);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false);
                    return;
                }
                setLoading(false);
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject(error);
            });
    };

    const CadastrarCobertura = async (event, currentPage) => {
        event.preventDefault();
        const token = Cookies.get("Token");
        if (CadastroCobertura === "") {
            setLoading(false);
            setError("Formulário vazio.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        if (typeof CadastroCobertura.nome === "undefined" || CadastroCobertura.nome === "") {
            setLoading(false);
            setError("Nome não informado");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        const data = {
            empresaKey: EmpresaKey,
            nome: CadastroCobertura.nome,
            descricao: CadastroCobertura.descricao,
            ativo: true,
            idExterno: CadastroCobertura.idExterno
        };
        return axios({
            url: baseurl + "Cobertura/Adicionar",
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                ListaCoberturaConsulta(currentPage, 10);
                setSuccess("Cobertura cadastrada com sucesso!");
                setCadastroCobertura({ descricao: "" });
                setOpenModal(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject(error);
            });
    };

    const ListaCobertura = useCallback(async () => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Cobertura/Listar?empresaKey=" + EmpresaKey + "&somenteAtivas=S",
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setCoberturas(response.data);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const [filtroCobertura, setFiltroCobertura] = useState([]);
    const [totalRegistrosFiltroCobertura, setTotalRegistrosFiltroCobertura] = useState(0);

    const ListaFiltroCobertura = useCallback(async (filtro, posicao, quantidade) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Cobertura/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setFiltroCobertura(response.data.data);
                setTotalRegistrosFiltroCobertura(response.data.total);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const [totalRegistrosCobertura, setTotalRegistrosCobertura] = useState(0);

    const ListaCoberturaConsulta = useCallback(async (posicao, qtd) => {
        try {
            const token = Cookies.get("Token");
            const response = await axios({
                url: `${baseurl}Cobertura/ListarConsulta?empresaKey=${EmpresaKey}&posicao=${posicao}&quantidade=${qtd}&somenteAtivas=N`,
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });
            setLoading(false);
            const user = eval(response.data.data);
            const arrayArea = user.map((e) => ({
                nome: e.nome,
                descricao: e.descricao,
                key: e.key,
                ativo: e.ativo,
                id: e.id,
                idExterno: e.idExterno
            }));
            setCoberturasConsulta((prevAreas) => {
                const isEqual = JSON.stringify(prevAreas) === JSON.stringify(arrayArea);
                return isEqual ? prevAreas : arrayArea;
            });
            setTotalRegistrosCobertura(response.data.totalRegistros);
        } catch (error) {
            setLoading(false);
            if (error.response.status === 401) {
                setError(`Sua sessão expirou, faça login novamente`);
                setTimeout(() => {
                    setError("");
                }, 3000);
                setAuth(false);
                return;
            }
            error.response.data.map((er) => {
                setError(`${er.campo}: ${er.mensagem}`);
            });
            setTimeout(() => {
                setError("");
            }, 3000);
            return Promise.reject(error);
        }
    });

    const EditarCobertura = async (currentPage) => {
        const token = Cookies.get("Token");
        const data = {
            empresaKey: EmpresaKey,
            nome: EdicaoCobertura.nome,
            descricao: EdicaoCobertura.descricao,
            ativo: EdicaoCobertura.ativo,
            idExterno: EdicaoCobertura.idExterno,
            empresaKey: EmpresaKey
        };
        return axios({
            url: baseurl + "Cobertura/Alterar?key=" + CoberturaAtualKey,
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                ListaCoberturaConsulta(currentPage, 10);
                setSuccess("Cobertura editada com sucesso!");
                setModalEditarCobertura(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    };

    const InativarCobertura = async (key, status) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Cobertura/Ativo?key=" + key + "&status=" + status,
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setCoberturasConsulta(prev =>
                    prev.map(item =>
                        item.key === key ? { ...item, ativo: status } : item
                    )
                );
                setSuccess("Cobertura ativada/inativada com sucesso!");
                setModalEditarCobertura(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    };

    const ExcluirCobertura = async (key, currentPage) => {
        setLoading(true);
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Cobertura/Deletar?key=" + key,
            method: "DELETE",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setLoading(false);
                ListaCoberturaConsulta(currentPage, 10);
                setSuccess("Cobertura excluída com sucesso!");
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setModalExcluirCobertura(false);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false);
                    return;
                }
                setLoading(false);
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject(error);
            });
    };

    const CadastrarTipoServico = async (event, currentPage) => {
        event.preventDefault();
        const token = Cookies.get("Token");
        if (CadastroTipoServico === "") {
            setLoading(false);
            setError("Formulário vazio.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        if (typeof CadastroTipoServico.nome === "undefined" || CadastroTipoServico.nome === "") {
            setLoading(false);
            setError("Nome não informado");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        const data = {
            empresaKey: EmpresaKey,
            nome: CadastroTipoServico.nome,
            descricao: CadastroTipoServico.descricao,
            ativo: true,
            idExterno: CadastroTipoServico.idExterno
        };
        return axios({
            url: baseurl + "TipoServico/Adicionar",
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                ListaTipoServicoConsulta(currentPage, 10);
                setSuccess("Tipo de Serviço cadastrado com sucesso!");
                setCadastroTipoServico({ descricao: "" });
                setOpenModal(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject(error);
            });
    };

    const ListaTipoServico = useCallback(async () => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "TipoServico/Listar?empresaKey=" + EmpresaKey + "&somenteAtivas=S",
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setTiposServico(response.data);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const [totalRegistrosTipoServico, setTotalRegistrosTipoServico] = useState(0);

    const ListaTipoServicoConsulta = useCallback(async (posicao, qtd) => {
        try {
            const token = Cookies.get("Token");
            const response = await axios({
                url: `${baseurl}TipoServico/ListarConsulta?empresaKey=${EmpresaKey}&posicao=${posicao}&quantidade=${qtd}&somenteAtivas=N`,
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });
            setLoading(false);
            const user = eval(response.data.data);
            const arrayArea = user.map((e) => ({
                nome: e.nome,
                descricao: e.descricao,
                key: e.key,
                ativo: e.ativo,
                id: e.id,
                idExterno: e.idExterno
            }));
            setTiposServicoConsulta((prevAreas) => {
                const isEqual = JSON.stringify(prevAreas) === JSON.stringify(arrayArea);
                return isEqual ? prevAreas : arrayArea;
            });
            setTotalRegistrosTipoServico(response.data.totalRegistros);
        } catch (error) {
            setLoading(false);
            if (error.response.status === 401) {
                setError(`Sua sessão expirou, faça login novamente`);
                setTimeout(() => {
                    setError("");
                }, 3000);
                setAuth(false);
                return;
            }
            error.response.data.map((er) => {
                setError(`${er.campo}: ${er.mensagem}`);
            });
            setTimeout(() => {
                setError("");
            }, 3000);
            return Promise.reject(error);
        }
    });

    const [filtroTipoServico, setFiltroTipoServico] = useState([]);
    const [totalRegistrosFiltroTipoServico, setTotalRegistrosFiltroTipoServico] = useState(0);

    const ListaFiltroTipoServico = useCallback(async (filtro, posicao, quantidade) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "TipoServico/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setFiltroTipoServico(response.data.data);
                setTotalRegistrosFiltroTipoServico(response.data.totalRegistros);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const EditarTipoServico = async (currentPage) => {
        const token = Cookies.get("Token");
        const data = {
            empresaKey: EmpresaKey,
            nome: EdicaoTipoServico.nome,
            descricao: EdicaoTipoServico.descricao,
            ativo: EdicaoTipoServico.ativo,
            idExterno: EdicaoTipoServico.idExterno,
            empresaKey: EmpresaKey
        };
        return axios({
            url: baseurl + "TipoServico/Alterar?key=" + TipoServicoAtualKey,
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                ListaTipoServicoConsulta(currentPage, 10);
                setSuccess("Tipo de Serviço editado com sucesso!");
                setModalEditarTipoServico(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    };

    const InativarTipoServico = async (key, status) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "TipoServico/Ativo?key=" + key + "&status=" + status,
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setTiposServicoConsulta(prev =>
                    prev.map(item =>
                        item.key === key ? { ...item, ativo: status } : item
                    )
                );
                setSuccess("Tipo de Serviço ativado/inativado com sucesso!");
                setModalEditarTipoServico(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    };

    const ExcluirTipoServico = async (key, currentPage) => {
        setLoading(true);
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "TipoServico/Deletar?key=" + key,
            method: "DELETE",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setLoading(false);
                ListaTipoServicoConsulta(currentPage, 10);
                setSuccess("Tipo de Serviço excluído com sucesso!");
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setModalExcluirTipoServico(false);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false);
                    return;
                }
                setLoading(false);
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject(error);
            });
    };

    const CadastrarPratica = async (event, currentPage) => {
        event.preventDefault();
        const token = Cookies.get("Token");
        if (CadastroPratica === "") {
            setLoading(false);
            setError("Formulário vazio.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        if (typeof CadastroPratica.nome === "undefined" || CadastroPratica.nome === "") {
            setLoading(false);
            setError("Nome não informado");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        const data = {
            empresaKey: EmpresaKey,
            nome: CadastroPratica.nome,
            descricao: CadastroPratica.descricao,
            anexo: FormAnexo,
            ativo: true,
            idExterno: CadastroPratica.idExterno
        };
        return axios({
            url: baseurl + "PraticasReferencia/Adicionar",
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                ListaPraticaConsulta(currentPage, 10);
                setSuccess("Prática cadastrada com sucesso!");
                setCadastroPratica({ descricao: "", nome: "" });
                setFormAnexo([])
                setOpenModal(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject(error);
            });
    };

    const ListaPratica = useCallback(async () => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "PraticasReferencia/Listar?empresaKey=" + EmpresaKey + "&somenteAtivas=S",
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setPraticas(response.data);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const [totalRegistrosPratica, setTotalRegistrosPratica] = useState(0);

    const ListaPraticaConsulta = useCallback(async (posicao, qtd) => {
        try {
            const token = Cookies.get("Token");
            const response = await axios({
                url: `${baseurl}PraticasReferencia/ListarConsulta?empresaKey=${EmpresaKey}&posicao=${posicao}&quantidade=${qtd}&somenteAtivas=N`,
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });
            setLoading(false);
            const user = eval(response.data.data);
            const arrayArea = user.map((e) => ({
                nome: e.nome,
                descricao: e.descricao,
                key: e.key,
                ativo: e.ativo,
                id: e.id,
                idExterno: e.idExterno
            }));
            setPraticasConsulta((prevAreas) => {
                const isEqual = JSON.stringify(prevAreas) === JSON.stringify(arrayArea);
                return isEqual ? prevAreas : arrayArea;
            });
            setTotalRegistrosPratica(response.data.totalRegistros);
        } catch (error) {
            setLoading(false);
            if (error.response.status === 401) {
                setError(`Sua sessão expirou, faça login novamente`);
                setTimeout(() => {
                    setError("");
                }, 3000);
                setAuth(false);
                return;
            }
            error.response.data.map((er) => {
                setError(`${er.campo}: ${er.mensagem}`);
            });
            setTimeout(() => {
                setError("");
            }, 3000);
            return Promise.reject(error);
        }
    });

    const [filtroPratica, setFiltroPratica] = useState([]);
    const [totalRegistrosFiltroPratica, setTotalRegistrosFiltroPratica] = useState(0);

    const ListaFiltroPratica = useCallback(async (filtro, posicao, quantidade) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "PraticasReferencia/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setFiltroPratica(response.data.data);
                setTotalRegistrosFiltroPratica(response.data.totalRegistros);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const EditarPratica = async (currentPage) => {
        const token = Cookies.get("Token");
        const data = {
            empresaKey: EmpresaKey,
            nome: EdicaoPratica.nome,
            descricao: EdicaoPratica.descricao,
            ativo: EdicaoPratica.ativo,
            idExterno: EdicaoPratica.idExterno,
            empresaKey: EmpresaKey
        };
        return axios({
            url: baseurl + "PraticasReferencia/Alterar?key=" + PraticaAtualKey,
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                ListaPraticaConsulta(currentPage, 10);
                setSuccess("Prática editada com sucesso!");
                setModalEditarPratica(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    };

    const InativarPratica = async (key, status) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "PraticasReferencia/Ativo?key=" + key + "&status=" + status,
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setPraticasConsulta(prev =>
                    prev.map(item =>
                        item.key === key ? { ...item, ativo: status } : item
                    )
                );
                setSuccess("Prática ativada/inativada com sucesso!");
                setModalEditarPratica(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    };

    const ExcluirPratica = async (key, currentPage) => {
        setLoading(true);
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "PraticasReferencia/Deletar?key=" + key,
            method: "DELETE",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setLoading(false);
                ListaPraticaConsulta(currentPage, 10);
                setSuccess("Prática excluída com sucesso!");
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setModalExcluirPratica(false);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false);
                    return;
                }
                setLoading(false);
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject(error);
            });
    };

    const AdicionarAnexo = async () => {
        const token = Cookies.get("Token");

        if (!AddFile) {
            setError("Campo anexo em branco.");
            setTimeout(() => setError(""), 3000);
            return;
        }

        const convertFileToBase64 = (file) => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result.split(",")[1]);
                reader.onerror = (error) => reject(error);
            });
        };

        try {
            const base64File = await convertFileToBase64(AddFile);

            const data = {
                praticaReferenciaKey: PraticaAtualKey,
                file: base64File,
                fileName: AddFile.name,
                contentType: AddFile.type
            };

            await axios.post(baseurl + "PraticasReferencia/AdicionarAnexo", data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            ListaAnexo()
            setSuccess("Anexo adicionado com sucesso.");
            setTimeout(() => setSuccess(""), 3000);
        } catch (error) {
            console.error(error);
            setError("Erro ao adicionar anexo.");
            setTimeout(() => setError(""), 3000);
        } finally {
            setLoading(false);
        }
    };

    const ListaAnexo = useCallback(async () => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "PraticasReferencia/ListarAnexo?demandaKey=" + PraticaAtualKey,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setFile(response.data);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    })

    const BaixarAnexo = useCallback(async (key) => {
        const token = Cookies.get("Token");

        try {
            const response = await axios.get(`${baseurl}PraticasReferencia/BaixarAnexo?key=${key}`, {
                responseType: "blob",
                headers: { Authorization: `Bearer ${token}` },
            });

            const blob = new Blob([response.data], { type: response.headers["content-type"] });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;

            let fileName = "arquivo";
            const contentDisposition = response.headers["content-disposition"];

            if (contentDisposition) {
                const match = contentDisposition.match(/filename="?(.+?)"?$/);
                if (match) fileName = match[1];
            } else {
                const extension = response.headers["content-type"].split("/")[1];
                fileName = `arquivo.${extension}`;
            }

            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Erro ao baixar o anexo:", error);
        }
    });

    const ExcluirAnexo = async (key) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "PraticasReferencia/ExcluirAnexo?key=" + key,
            method: "DELETE",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                ListaAnexo()
                setSuccess(response.data);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setLoading(false);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false)
                    return
                }
                setLoading(false);
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    }

    const CadastrarOrganizacao = async (event, currentPage) => {
        event.preventDefault();
        const token = Cookies.get("Token");
        if (CadastroOrganizacao === "") {
            setLoading(false);
            setError("Formulário vazio.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        if (typeof CadastroOrganizacao.nome === "undefined" || CadastroOrganizacao.nome === "") {
            setLoading(false);
            setError("Nome não informado");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        const data = {
            empresaKey: EmpresaKey,
            nome: CadastroOrganizacao.nome,
            descricao: CadastroOrganizacao.descricao,
            ativo: true,
            idExterno: CadastroOrganizacao.idExterno
        };
        return axios({
            url: baseurl + "Organizacao/Adicionar",
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                ListaOrganizacaoConsulta(currentPage, 10);
                setSuccess("Organização cadastrada com sucesso!");
                setCadastroOrganizacao({ descricao: "" });
                setOpenModal(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject(error);
            });
    };

    const ListaOrganizacao = useCallback(async () => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Organizacao/Listar?empresaKey=" + EmpresaKey + "&somenteAtivas=S",
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setOrganizacoes(response.data);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const [totalRegistrosOrganizacao, setTotalRegistrosOrganizacao] = useState(0);

    const ListaOrganizacaoConsulta = useCallback(async (posicao, qtd) => {
        try {
            const token = Cookies.get("Token");
            const response = await axios({
                url: `${baseurl}Organizacao/ListarConsulta?empresaKey=${EmpresaKey}&posicao=${posicao}&quantidade=${qtd}&somenteAtivas=N`,
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });
            setLoading(false);
            const user = eval(response.data.data);
            const arrayArea = user.map((e) => ({
                nome: e.nome,
                descricao: e.descricao,
                ativo: e.ativo,
                key: e.key,
                id: e.id,
                idExterno: e.idExterno
            }));
            setOrganizacoesConsulta((prevAreas) => {
                const isEqual = JSON.stringify(prevAreas) === JSON.stringify(arrayArea);
                return isEqual ? prevAreas : arrayArea;
            });
            setTotalRegistrosOrganizacao(response.data.totalRegistros)
        } catch (error) {
            // if (error.response.status === 401) {
            //     setError(`Sua sessão expirou, faça login novamente`);
            //     setTimeout(() => {
            //         setError("");
            //     }, 3000);
            //     setAuth(false);
            //     return;
            // }
            // error.response.data.map((er) => {
            //     setError(`${er.campo}: ${er.mensagem}`);
            // });
            // setTimeout(() => {
            //     setError("");
            // }, 3000);
            console.log(error)
            return Promise.reject(error);
        }
    });

    const [filtroOrganizacao, setFiltroOrganizacao] = useState([]);
    const [totalRegistrosFiltroOrganizacao, setTotalRegistrosFiltroOrganizacao] = useState(0);

    const ListaFiltroOrganizacao = useCallback(async (filtro, posicao, quantidade) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Organizacao/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setFiltroOrganizacao(response.data.data);
                setTotalRegistrosFiltroOrganizacao(response.data.totalRegistros);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const EditarOrganizacao = async (currentPage) => {
        const token = Cookies.get("Token");
        const data = {
            empresaKey: EmpresaKey,
            nome: EdicaoOrganizacao.nome,
            descricao: EdicaoOrganizacao.descricao,
            ativo: EdicaoOrganizacao.ativo,
            idExterno: EdicaoOrganizacao.idExterno
        };
        return axios({
            url: baseurl + "Organizacao/Alterar?key=" + OrganizacaoAtualKey,
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                ListaOrganizacaoConsulta(currentPage, 10);
                setSuccess("Organização editada com sucesso!");
                setModalEditarOrganizacao(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    };

    const InativarOrganizacao = async (key, status) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Organizacao/Ativo?key=" + key + "&status=" + status,
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setOrganizacoesConsulta(prev =>
                    prev.map(item =>
                        item.key === key ? { ...item, ativo: status } : item
                    )
                );
                setSuccess("Organização ativada/inativada com sucesso!");
                setModalEditarOrganizacao(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    };

    const ExcluirOrganizacao = async (key, currentPage) => {
        setLoading(true);
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Organizacao/Deletar?key=" + key,
            method: "DELETE",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setLoading(false);
                ListaOrganizacaoConsulta(currentPage, 10);
                setSuccess("Organização excluída com sucesso!");
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setModalExcluirOrganizacao(false);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false);
                    return;
                }
                setLoading(false);
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject(error);
            });
    };

    const CadastrarLocalidade = async (event, currentPage) => {
        event.preventDefault();
        const token = Cookies.get("Token");
        if (CadastroLocalidade === "") {
            setLoading(false);
            setError("Formulário vazio.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        if (typeof CadastroLocalidade.nome === "undefined" || CadastroLocalidade.nome === "") {
            setLoading(false);
            setError("Nome não informado");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        const data = {
            empresaKey: EmpresaKey,
            organizacaoKey: CadastroLocalidade.organizacaoKey,
            nome: CadastroLocalidade.nome,
            descricao: CadastroLocalidade.descricao,
            ativo: true,
            idExterno: CadastroLocalidade.idExterno
        };
        return axios({
            url: baseurl + "Localidade/Adicionar",
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                ListaLocalidadeConsulta(currentPage, 10);
                setSuccess("Localidade cadastrada com sucesso!");
                setCadastroLocalidade({ descricao: "", nome: "", organizacaoKey: "" });
                setOpenModal(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject(error);
            });
    };

    const ListaLocalidade = useCallback(async () => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Localidade/Listar?empresaKey=" + EmpresaKey + "&somenteAtivas=S",
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setLocalidades(response.data);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const [totalRegistrosLocalidade, setTotalRegistrosLocalidade] = useState(0);

    const ListaLocalidadeConsulta = useCallback(async (posicao, qtd) => {
        try {
            const token = Cookies.get("Token");
            const response = await axios({
                url: `${baseurl}Localidade/ListarConsulta?empresaKey=${EmpresaKey}&posicao=${posicao}&quantidade=${qtd}&somenteAtivas=N`,
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });
            setLoading(false);
            const user = eval(response.data.data);
            const arrayArea = user.map((e) => ({
                nome: e.nome,
                descricao: e.descricao,
                organizacao: e.organizacao,
                key: e.key,
                ativo: e.ativo,
                id: e.id,
                idExterno: e.idExterno
            }));
            setLocalidadesConsulta((prevAreas) => {
                const isEqual = JSON.stringify(prevAreas) === JSON.stringify(arrayArea);
                return isEqual ? prevAreas : arrayArea;
            });
            setTotalRegistrosLocalidade(response.data.totalRegistros)
        } catch (error) {
            setLoading(false);
            if (error.response.status === 401) {
                setError(`Sua sessão expirou, faça login novamente`);
                setTimeout(() => {
                    setError("");
                }, 3000);
                setAuth(false);
                return;
            }
            error.response.data.map((er) => {
                setError(`${er.campo}: ${er.mensagem}`);
            });
            setTimeout(() => {
                setError("");
            }, 3000);
            return Promise.reject(error);
        }
    });

    const [filtroLocalidade, setFiltroLocalidade] = useState([]);
    const [totalRegistrosFiltroLocalidade, setTotalRegistrosFiltroLocalidade] = useState(0);

    const ListaFiltroLocalidade = useCallback(async (filtro, posicao, quantidade) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Localidade/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setFiltroLocalidade(response.data.data);
                setTotalRegistrosFiltroLocalidade(response.data.totalRegistros);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const EditarLocalidade = async (organizacaoKey, currentPage) => {
        const token = Cookies.get("Token");
        const data = {
            empresaKey: EmpresaKey,
            nome: EdicaoLocalidade.nome,
            descricao: EdicaoLocalidade.descricao,
            organizacaoKey: organizacaoKey,
            ativo: EdicaoLocalidade.ativo,
            idExterno: EdicaoLocalidade.idExterno,
            empresaKey: EmpresaKey
        };
        return axios({
            url: baseurl + "Localidade/Alterar?key=" + LocalidadeAtualKey,
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                ListaLocalidadeConsulta(currentPage, 10);
                setSuccess("Localidade editada com sucesso!");
                setModalEditarLocalidade(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    };

    const InativarLocalidade = async (key, status) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Localidade/Ativo?key=" + key + "&status=" + status,
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setLocalidadesConsulta(prev =>
                    prev.map(item =>
                        item.key === key ? { ...item, ativo: status } : item
                    )
                );
                setSuccess("Localidade ativada/inativada com sucesso!");
                setModalEditarLocalidade(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    };

    const ExcluirLocalidade = async (key, currentPage) => {
        setLoading(true);
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Localidade/Deletar?key=" + key,
            method: "DELETE",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setLoading(false);
                ListaLocalidadeConsulta(currentPage, 10);
                setSuccess("Localidade excluída com sucesso!");
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setModalExcluirLocalidade(false);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false);
                    return;
                }
                setLoading(false);
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject(error);
            });
    };

    const CadastrarFornecedor = async (event, currentPage) => {
        event.preventDefault();
        const token = Cookies.get("Token");
        if (CadastroFornecedor === "") {
            setLoading(false);
            setError("Formulário vazio.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        if (typeof CadastroFornecedor.fantasia === "undefined" || CadastroFornecedor.fantasia === "") {
            setLoading(false);
            setError("Fantasia não informada");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        if (typeof CadastroFornecedor.razaoSocial === "undefined" || CadastroFornecedor.razaoSocial === "") {
            setLoading(false);
            setError("Razão Social não informada");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        if (typeof CadastroFornecedor.documento === "undefined" || CadastroFornecedor.documento === "") {
            setLoading(false);
            setError("Documento não informado");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        const data = {
            empresaKey: EmpresaKey,
            fantasia: CadastroFornecedor.fantasia,
            razaoSocial: CadastroFornecedor.razaoSocial,
            documento: CadastroFornecedor.documento,
            site: CadastroFornecedor.site,
            email: CadastroFornecedor.email,
            cep: CadastroFornecedor.cep,
            cidade: CadastroFornecedor.cidade,
            uf: CadastroFornecedor.uf,
            endereco: CadastroFornecedor.endereco,
            numero: CadastroFornecedor.numero,
            bairro: CadastroFornecedor.bairro,
            complemento: CadastroFornecedor.complemento,
            telefone: CadastroFornecedor.telefone,
            ativo: true,
            idExterno: CadastroFornecedor.idExterno
        };
        return axios({
            url: baseurl + "Fornecedor/Adicionar",
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                ListaFornecedorConsulta(currentPage, 10);
                setSuccess("Fornecedor cadastrado com sucesso!");
                setCadastroLocalidade({ fantasia: "", razaoSocial: "", documento: "", site: "", email: "", cep: "", cidade: "", uf: "", endereco: "", numero: "", bairro: "", complemento: "", telefone: "" });
                setOpenModal(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject(error);
            });
    };

    const ListaFornecedor = useCallback(async () => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Fornecedor/Listar?empresaKey=" + EmpresaKey + "&somenteAtivas=S",
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setFornecedores(response.data);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const [totalRegistrosFornecedor, setTotalRegistrosFornecedor] = useState(0);

    const ListaFornecedorConsulta = useCallback(async (posicao, qtd) => {
        try {
            const token = Cookies.get("Token");
            const response = await axios({
                url: `${baseurl}Fornecedor/ListarConsulta?empresaKey=${EmpresaKey}&posicao=${posicao}&quantidade=${qtd}&somenteAtivas=N`,
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });
            setLoading(false);
            const user = eval(response.data.data);
            const arrayArea = user.map((e) => ({
                fantasia: e.fantasia,
                razaoSocial: e.razaoSocial,
                documento: e.documento,
                site: e.site,
                email: e.email,
                cep: e.cep,
                cidade: e.cidade,
                uf: e.uf,
                endereco: e.endereco,
                numero: e.numero,
                bairro: e.bairro,
                complemento: e.complemento,
                telefone: e.telefone,
                key: e.key,
                ativo: e.ativo,
                id: e.id,
                idExterno: e.idExterno
            }));
            setFornecedoresConsulta((prevAreas) => {
                const isEqual = JSON.stringify(prevAreas) === JSON.stringify(arrayArea);
                return isEqual ? prevAreas : arrayArea;
            });
            setTotalRegistrosFornecedor(response.data.totalRegistros)
        } catch (error) {
            setLoading(false);
            if (error.response.status === 401) {
                setError(`Sua sessão expirou, faça login novamente`);
                setTimeout(() => {
                    setError("");
                }, 3000);
                setAuth(false);
                return;
            }
            error.response.data.map((er) => {
                setError(`${er.campo}: ${er.mensagem}`);
            });
            setTimeout(() => {
                setError("");
            }, 3000);
            return Promise.reject(error);
        }
    });

    const [filtroFornecedor, setFiltroFornecedor] = useState([]);
    const [totalRegistrosFiltroFornecedor, setTotalRegistrosFiltroFornecedor] = useState(0);

    const ListaFiltroFornecedor = useCallback(async (filtro, posicao, quantidade) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Fornecedor/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setFiltroFornecedor(response.data.data);
                setTotalRegistrosFiltroFornecedor(response.data.totalRegistros);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const EditarFornecedor = async (currentPage) => {
        const token = Cookies.get("Token");
        const data = {
            empresaKey: EmpresaKey,
            fantasia: EdicaoFornecedor.fantasia,
            razaoSocial: EdicaoFornecedor.razaoSocial,
            documento: EdicaoFornecedor.documento,
            site: EdicaoFornecedor.site,
            email: EdicaoFornecedor.email,
            cep: EdicaoFornecedor.cep,
            cidade: EdicaoFornecedor.cidade,
            uf: EdicaoFornecedor.uf,
            endereco: EdicaoFornecedor.endereco,
            numero: EdicaoFornecedor.numero,
            bairro: EdicaoFornecedor.bairro,
            complemento: EdicaoFornecedor.complemento,
            telefone: EdicaoFornecedor.telefone,
            ativo: EdicaoFornecedor.ativo,
            idExterno: EdicaoFornecedor.idExterno,
            empresaKey: EmpresaKey
        };
        return axios({
            url: baseurl + "Fornecedor/Alterar?key=" + FornecedorAtualKey,
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                ListaFornecedorConsulta(currentPage, 10);
                setSuccess("Fornecedor editado com sucesso!");
                setModalEditarFornecedor(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    };

    const InativarFornecedor = async (key, status) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Fornecedor/Ativo?key=" + key + "&status=" + status,
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setFornecedoresConsulta(prev =>
                    prev.map(item =>
                        item.key === key ? { ...item, ativo: status } : item
                    )
                );
                setSuccess("Fornecedor ativado/inativado com sucesso!");
                setModalEditarFornecedor(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    };

    const ExcluirFornecedor = async (key, currentPage) => {
        setLoading(true);
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Fornecedor/Deletar?key=" + key,
            method: "DELETE",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                ListaFornecedorConsulta(currentPage, 10);
                setSuccess("Fornecedor excluído com sucesso!");
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setModalExcluirFornecedor(false);
                setLoading(false);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false);
                    return;
                }
                setLoading(false);
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject(error);
            });
    };

    const CadastrarServico = async (event, currentPage) => {
        setLoading(true)
        event.preventDefault();
        const token = Cookies.get("Token");
        if (CadastroServico === "") {
            setLoading(false);
            setError("Formulário vazio.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        const data = {
            empresaKey: EmpresaKey,
            descricao: CadastroServico.descricao,
            objetivo: CadastroServico.objetivo,
            escopo: CadastroServico.escopo,
            exclusoes: CadastroServico.exclusoes,
            grupoKey: CadastroServico.grupoKey,
            subGrupoKey: CadastroServico.subGrupoKey,
            itemKey: CadastroServico.itemKey,
            cargoDonoKey: CadastroServico.cargoDonoKey,
            tipoServicoKey: CadastroServico.tipoServicoKey,
            slaAtendimentoKey: CadastroServico.slaAtendimentoKey,
            slaSolucaoKey: CadastroServico.slaSolucaoKey,
            periodicidadeKey: CadastroServico.periodicidadeKey,
            coberturaKey: CadastroServico.coberturaKey,
            metodoSolicitacaoKey: CadastroServico.metodoSolicitacaoKey,
            anexos: FormAnexoServico,
            links: FormLink,
            organizacoes: CadastroServico.organizacoes,
            areas: CadastroServico.areas,
            praticas: CadastroServico.praticas,
            fornecedores: CadastroServico.fornecedores,
            localidades: CadastroServico.localidades,
            linhasExecutores: CadastroServico.linhasExecutores,
            sistemas: CadastroServico.sistemas,
            ativo: true,
            idExterno: CadastroServico.idExterno
        };
        return axios({
            url: baseurl + "Servico/Adicionar",
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                setLoading(false)
                ListaServicoConsulta(currentPage, 10);
                setSuccess("Serviço cadastrado com sucesso!");
                setCadastroLocalidade({});
                setOpenModal(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                setLoading(false)
                return Promise.reject(error);
            });
    };

    const ListaServico = useCallback(async () => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Servico/Listar?empresaKey=" + EmpresaKey + "&somenteAtivas=S",
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setServicos(response.data);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const ObterServico = useCallback(async (key) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Servico/Obter?key=" + key,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setServicoObter(response.data);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const [totalRegistrosServico, setTotalRegistrosServico] = useState(0);

    const ListaServicoConsulta = useCallback(async (posicao, qtd) => {
        try {
            const token = Cookies.get("Token");
            const response = await axios({
                url: `${baseurl}Servico/ListarConsulta?empresaKey=${EmpresaKey}&posicao=${posicao}&quantidade=${qtd}&somenteAtivas=N`,
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });
            setLoading(false);
            const user = eval(response.data.data);
            const arrayArea = user.map((e) => ({
                descricao: e.descricao,
                grupo: e.grupo,
                subGrupo: e.subGrupo,
                item: e.item,
                objetivo: e.objetivo,
                escopo: e.escopo,
                exclusoes: e.exclusoes,
                tipoServico: e.tipoServico,
                slaAtendimento: e.slaAtendimento,
                slaSolucao: e.slaSolucao,
                periodicidade: e.periodicidade,
                cobertura: e.cobertura,
                key: e.key,
                cargoDono: e.cargoDono,
                localidade: e.localidade,
                fornecedor: e.fornecedor,
                metodoSolicitacao: e.metodoSolicitacao,
                ativo: e.ativo,
                id: e.id,
                idExterno: e.idExterno
            }));
            setServicosConsulta((prevAreas) => {
                const isEqual = JSON.stringify(prevAreas) === JSON.stringify(arrayArea);
                return isEqual ? prevAreas : arrayArea;
            });
            setTotalRegistrosServico(response.data.totalRegistros)
        } catch (error) {
            setLoading(false);
            if (error.response.status === 401) {
                setError(`Sua sessão expirou, faça login novamente`);
                setTimeout(() => {
                    setError("");
                }, 3000);
                setAuth(false);
                return;
            }
            error.response.data.map((er) => {
                setError(`${er.campo}: ${er.mensagem}`);
            });
            setTimeout(() => {
                setError("");
            }, 3000);
            return Promise.reject(error);
        }
    });

    const [filtroServico, setFiltroServico] = useState([]);
    const [totalRegistrosFiltroServico, setTotalRegistrosFiltroServico] = useState(0);

    const ListaFiltroServico = useCallback(async (filtro, posicao, quantidade) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Servico/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setFiltroServico(response.data.data);
                setTotalRegistrosFiltroServico(response.data.totalRegistros);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const EditarServico = async (grupoKey, subGrupoKey, itemKey, cargoDonoKey, tipoServicoKey, slaAtendimentoKey, slaSolucaoKey, periodicidadeKey, coberturaKey, metodoSolicitacaoKey, currentPage) => {
        setLoading(true)
        const token = Cookies.get("Token");
        const data = {
            empresaKey: EmpresaKey,
            descricao: EdicaoServico.descricao,
            objetivo: EdicaoServico.objetivo,
            escopo: EdicaoServico.escopo,
            exclusoes: EdicaoServico.exclusoes,
            grupoKey: grupoKey,
            subGrupoKey: subGrupoKey,
            itemKey: itemKey,
            cargoDonoKey: cargoDonoKey,
            tipoServicoKey: tipoServicoKey,
            slaAtendimentoKey: slaAtendimentoKey,
            slaSolucaoKey: slaSolucaoKey,
            periodicidadeKey: periodicidadeKey,
            coberturaKey: coberturaKey,
            metodoSolicitacaoKey: metodoSolicitacaoKey,
            organizacoes: EdicaoServico.organizacoes,
            areas: EdicaoServico.areas,
            praticas: EdicaoServico.praticas,
            fornecedores: EdicaoServico.fornecedores,
            localidades: EdicaoServico.localidades,
            linhasExecutores: EdicaoServico.linhasExecutores,
            ativo: EdicaoServico.ativo,
            idExterno: EdicaoServico.idExterno,
            empresaKey: EmpresaKey
        };
        return axios({
            url: baseurl + "Servico/Alterar?key=" + ServicoAtualKey,
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                setLoading(false)
                ListaServicoConsulta(currentPage, 10);
                setSuccess("Serviço editado com sucesso!");
                setModalEditarServico(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
            })
            .catch((error) => {
                setLoading(false)
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    };

    const InativarServico = async (key, status) => {
        setLoading(true);
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Servico/Ativo?key=" + key + "&status=" + status,
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setServicosConsulta(prev =>
                    prev.map(item =>
                        item.key === key ? { ...item, ativo: status } : item
                    )
                );
                setSuccess("Serviço ativado/inativado com sucesso!");
                setModalEditarServico(false);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    };

    const ExcluirServico = async (key, currentPage) => {
        setLoading(true);
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Servico/Excluir?key=" + key,
            method: "DELETE",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setLoading(false);
                ListaServicoConsulta(currentPage, 10);
                setSuccess("Serviço excluído com sucesso!");
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setModalExcluirServico(false);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false);
                    return;
                }
                setLoading(false);
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`);
                });
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject(error);
            });
    };

    const RetornaSubgrupo = useCallback(async (grupoKey) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Servico/RetornaSubGrupo?empresaKey=" + EmpresaKey + "&grupoKey=" + grupoKey,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setLoading(false);
                setServicoSubgrupo(response.data);
            })
            .catch((error) => {
                setLoading(false);
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                // error.response.data.map((er) => {
                //     setError(`${er.campo}: ${er.mensagem}`);
                // });
                console.log(error)
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const RetornaItem = useCallback(async (subGrupoKey) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Servico/RetornaItem?empresaKey=" + EmpresaKey + "&subGrupoKey=" + subGrupoKey,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setLoading(false);
                setServicoItem(response.data);
            })
            .catch((error) => {
                setLoading(false);
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                // error.response.data.map((er) => {
                //     setError(`${er.campo}: ${er.mensagem}`);
                // });
                console.log(error)
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const RetornaLocalidade = useCallback(async (organizacoesKey) => {
        const token = Cookies.get("Token");
        const data = {
            empresaKey: EmpresaKey,
            organizacoes: organizacoesKey,
        }
        return axios({
            url: baseurl + "Servico/RetornaLocalidades",
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then((response) => {
                setServicoLocalidade(response.data);
            })
            .catch((error) => {
                setLoading(false);
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`);
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false);
                    return;
                }
                // error.response.data.map((er) => {
                //     setError(`${er.campo}: ${er.mensagem}`);
                // });
                console.log(error)
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    });

    const AdicionarAnexoServico = async () => {
        const token = Cookies.get("Token");

        if (!AddFileServico) {
            setError("Campo anexo em branco.");
            setTimeout(() => setError(""), 3000);
            return;
        }

        const convertFileToBase64 = (file) => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result.split(",")[1]);
                reader.onerror = (error) => reject(error);
            });
        };

        try {
            const base64File = await convertFileToBase64(AddFileServico);

            const data = {
                servicoKey: ServicoAtualKey,
                file: base64File,
                fileName: AddFileServico.name,
                contentType: AddFileServico.type
            };

            await axios.post(baseurl + "Servico/AdicionarAnexo", data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            ListaAnexoServico()
            setSuccess("Anexo adicionado com sucesso.");
            setTimeout(() => setSuccess(""), 3000);
        } catch (error) {
            console.error(error);
            setError("Erro ao adicionar anexo.");
            setTimeout(() => setError(""), 3000);
        } finally {
            setLoading(false);
        }
    };

    const ListaAnexoServico = useCallback(async () => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Servico/ListarAnexo?servicoKey=" + ServicoAtualKey,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setFileServico(response.data);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    })

    const BaixarAnexoServico = useCallback(async (key) => {
        const token = Cookies.get("Token");

        try {
            const response = await axios.get(`${baseurl}Servico/BaixarAnexo?key=${key}`, {
                responseType: "blob",
                headers: { Authorization: `Bearer ${token}` },
            });

            const blob = new Blob([response.data], { type: response.headers["content-type"] });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;

            let fileName = "arquivo";
            const contentDisposition = response.headers["content-disposition"];

            if (contentDisposition) {
                const match = contentDisposition.match(/filename="?(.+?)"?$/);
                if (match) fileName = match[1];
            } else {
                const extension = response.headers["content-type"].split("/")[1];
                fileName = `arquivo.${extension}`;
            }

            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Erro ao baixar o anexo:", error);
        }
    });

    const ExcluirAnexoServico = async (key) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Servico/ExcluirAnexo?key=" + key,
            method: "DELETE",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                ListaAnexoServico()
                setSuccess(response.data);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setLoading(false);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false)
                    return
                }
                setLoading(false);
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    }

    const AdicionarLink = async () => {
        const token = Cookies.get("Token");
        const data = {
            servicoKey: ServicoAtualKey,
            link: AddLink.addLink,
            descricao: AddLink.descricaoLink,
        };
        try {
            if (typeof AddLink.addLink === "undefined") {
                setError("Campo link em branco.")
                setTimeout(() => {
                    setError("");
                }, 3000);
                return;
            }
        } catch (error) {
        }
        return axios({
            url: baseurl + "Servico/AdicionarLink",
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                ListaLink()
                setSuccess("Link adicionado com sucesso.");
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                linkRef.current.value = '';
                descricaoRef.current.value = '';
                setAddLink({
                    link: "",
                    descricao: "",
                });
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject(error);
            });
    }

    const ListaLink = useCallback(async () => {
        let arrayLink = [];
        let objLink = {};
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Servico/ListarLink?servicoKey=" + ServicoAtualKey,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                const user = eval(response.data);
                user.forEach((e) => {
                    objLink = {
                        nome: e.usuario.nome,
                        dataHora: e.dataHora,
                        descricao: e.descricao,
                        link: e.link,
                        keyLink: e.key
                    };
                    arrayLink.push(objLink);
                });
                setLink(arrayLink.reverse());
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                console.log(error)
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    })

    const ExcluirLink = async (key) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Servico/ExcluirLink?key=" + key,
            method: "DELETE",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                ListaLink();
                setSuccess(response.data);
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setLoading(false);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false)
                    return
                }
                setLoading(false);
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    }

    const ListaOrganizacaoServico = useCallback(async () => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Servico/ListarOrganizacao?servicoKey=" + ServicoAtualKey,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setServicoOrganizacao(response.data);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    })

    const ListaAreaServico = useCallback(async () => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Servico/ListarArea?servicoKey=" + ServicoAtualKey,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setServicoArea(response.data);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    })

    const ListaPraticaServico = useCallback(async () => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Servico/ListarPratica?servicoKey=" + ServicoAtualKey,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setServicoPratica(response.data);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    })

    const ListaFornecedorServico = useCallback(async () => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Servico/ListarFornecedor?servicoKey=" + ServicoAtualKey,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setServicoFornecedor(response.data);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    })

    const ListaExecutorServico = useCallback(async () => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Servico/ListarLinhaExecutor?servicoKey=" + ServicoAtualKey,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setServicoExecutor(response.data);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    })

    const ListaLocalidadeServico = useCallback(async () => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Servico/ListarLocalidade?servicoKey=" + ServicoAtualKey,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setServicoLocalidadeEditar(response.data);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    })

    const AdicionarSistemaServico = async (key) => {
        const token = Cookies.get("Token");
        const data = {
            sistemaKey: key,
            servicoKey: ServicoAtualKey,
        };
        return axios({
            url: baseurl + "Servico/AdicionarSistema",
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
            data: data,
        })
            .then(() => {
                ListaSistemaServico()
                setSuccess("Competência adicionada com sucesso.");
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject(error);
            });
    }

    const ListaSistemaServico = useCallback(async () => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Servico/ListarSistema?servicoKey=" + ServicoAtualKey,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setServicoSistema(response.data);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    })

    const ExcluirSistemaServico = async (key) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Servico/ExcluirSistema?key=" + key,
            method: "DELETE",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                ListaSistemaServico();
                setSuccess("Sistema excluído com sucesso.");
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setLoading(false);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false)
                    return
                }
                setLoading(false);
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    }

    const [AreaServicoDisponivel, setAreaServicoDisponivel] = useState([]);

    const ListaAreaDisponivel = useCallback(async () => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Servico/ListaAreaDisponivel?empresaKey=" + EmpresaKey,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setAreaServicoDisponivel(response.data);
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    })

    const data = {
        CadastroGrupo, setCadastroGrupo,
        Grupos, setGrupos,
        CadastrarGrupo,
        ListaGrupo,
        EditarGrupo,
        InativarGrupo,
        EdicaoGrupo, setEdicaoGrupo,
        GrupoAtualKey, setGrupoAtualKey,
        modalEditarGrupo, setModalEditarGrupo,
        ExcluirGrupo,
        modalExcluirGrupo, setModalExcluirGrupo,
        GruposConsulta, ListaGrupoConsulta,
        CadastroSubgrupo, setCadastroSubgrupo,
        Subgrupos, setSubgrupos,
        CadastrarSubgrupo,
        ListaSubgrupo,
        EditarSubgrupo,
        InativarSubgrupo,
        EdicaoSubgrupo, setEdicaoSubgrupo,
        SubgrupoAtualKey, setSubgrupoAtualKey,
        modalEditarSubgrupo, setModalEditarSubgrupo,
        ExcluirSubgrupo,
        modalExcluirSubgrupo, setModalExcluirSubgrupo,
        SubgruposConsulta, ListaSubgrupoConsulta,
        CadastroItem, setCadastroItem,
        Itens, setItens,
        CadastrarItem,
        ListaItem,
        EditarItem,
        InativarItem,
        EdicaoItem, setEdicaoItem,
        ItemAtualKey, setItemAtualKey,
        modalEditarItem, setModalEditarItem,
        ExcluirItem,
        modalExcluirItem, setModalExcluirItem,
        ItensConsulta, ListaItemConsulta,
        CadastroPeriodicidade, setCadastroPeriodicidade,
        Periodicidades, setPeriodicidades,
        CadastrarPeriodicidade,
        ListaPeriodicidade,
        EditarPeriodicidade,
        InativarPeriodicidade,
        EdicaoPeriodicidade, setEdicaoPeriodicidade,
        PeriodicidadeAtualKey, setPeriodicidadeAtualKey,
        modalEditarPeriodicidade, setModalEditarPeriodicidade,
        ExcluirPeriodicidade,
        modalExcluirPeriodicidade, setModalExcluirPeriodicidade,
        PeriodicidadesConsulta, ListaPeriodicidadeConsulta,
        CadastroSLA, setCadastroSLA,
        SLAs, setSLAs,
        CadastrarSLA,
        ListaSLA,
        EditarSLA,
        InativarSLA,
        EdicaoSLA, setEdicaoSLA,
        SLAAtualKey, setSLAAtualKey,
        modalEditarSLA, setModalEditarSLA,
        ExcluirSLA,
        modalExcluirSLA, setModalExcluirSLA,
        SLAsConsulta, ListaSLAConsulta,
        CadastroMetodo, setCadastroMetodo,
        Metodos, setMetodos,
        CadastrarMetodo,
        ListaMetodo,
        EditarMetodo,
        InativarMetodo,
        EdicaoMetodo, setEdicaoMetodo,
        MetodoAtualKey, setMetodoAtualKey,
        modalEditarMetodo, setModalEditarMetodo,
        ExcluirMetodo,
        modalExcluirMetodo, setModalExcluirMetodo,
        MetodosConsulta, ListaMetodoConsulta,
        CadastroCobertura, setCadastroCobertura,
        Coberturas, setCoberturas,
        CadastrarCobertura,
        ListaCobertura,
        EditarCobertura,
        InativarCobertura,
        EdicaoCobertura, setEdicaoCobertura,
        CoberturaAtualKey, setCoberturaAtualKey,
        modalEditarCobertura, setModalEditarCobertura,
        ExcluirCobertura,
        modalExcluirCobertura, setModalExcluirCobertura,
        CoberturasConsulta, ListaCoberturaConsulta,
        CadastroTipoServico, setCadastroTipoServico,
        TiposServico, setTiposServico,
        CadastrarTipoServico,
        ListaTipoServico,
        EditarTipoServico,
        InativarTipoServico,
        EdicaoTipoServico, setEdicaoTipoServico,
        TipoServicoAtualKey, setTipoServicoAtualKey,
        modalEditarTipoServico, setModalEditarTipoServico,
        ExcluirTipoServico,
        modalExcluirTipoServico, setModalExcluirTipoServico,
        TiposServicoConsulta, ListaTipoServicoConsulta,
        CadastroPratica, setCadastroPratica,
        Praticas, setPraticas,
        CadastrarPratica,
        ListaPratica,
        EditarPratica,
        InativarPratica,
        EdicaoPratica, setEdicaoPratica,
        PraticaAtualKey, setPraticaAtualKey,
        modalEditarPratica, setModalEditarPratica,
        ExcluirPratica,
        modalExcluirPratica, setModalExcluirPratica,
        PraticasConsulta, ListaPraticaConsulta,
        CadastroOrganizacao, setCadastroOrganizacao,
        Organizacoes, setOrganizacoes,
        CadastrarOrganizacao,
        ListaOrganizacao,
        EditarOrganizacao,
        InativarOrganizacao,
        EdicaoOrganizacao, setEdicaoOrganizacao,
        OrganizacaoAtualKey, setOrganizacaoAtualKey,
        modalEditarOrganizacao, setModalEditarOrganizacao,
        ExcluirOrganizacao,
        modalExcluirOrganizacao, setModalExcluirOrganizacao,
        OrganizacoesConsulta, ListaOrganizacaoConsulta,
        CadastroLocalidade, setCadastroLocalidade,
        Localidades, setLocalidades,
        CadastrarLocalidade,
        ListaLocalidade,
        EditarLocalidade,
        InativarLocalidade,
        EdicaoLocalidade, setEdicaoLocalidade,
        LocalidadeAtualKey, setLocalidadeAtualKey,
        modalEditarLocalidade, setModalEditarLocalidade,
        ExcluirLocalidade,
        modalExcluirLocalidade, setModalExcluirLocalidade,
        LocalidadesConsulta, ListaLocalidadeConsulta,
        CadastroFornecedor, setCadastroFornecedor,
        Fornecedores, setFornecedores,
        CadastrarFornecedor,
        ListaFornecedor,
        EditarFornecedor,
        InativarFornecedor,
        EdicaoFornecedor, setEdicaoFornecedor,
        FornecedorAtualKey, setFornecedorAtualKey,
        modalEditarFornecedor, setModalEditarFornecedor,
        ExcluirFornecedor,
        modalExcluirFornecedor, setModalExcluirFornecedor,
        FornecedoresConsulta, ListaFornecedorConsulta,
        CadastroServico, setCadastroServico,
        Servicos, setServicos,
        CadastrarServico,
        ListaServico,
        EditarServico,
        InativarServico,
        EdicaoServico, setEdicaoServico,
        ServicoAtualKey, setServicoAtualKey,
        modalEditarServico, setModalEditarServico,
        ExcluirServico,
        modalExcluirServico, setModalExcluirServico,
        ServicosConsulta, ListaServicoConsulta,
        RetornaSubgrupo, ServicoSubgrupo, setServicoSubgrupo,
        RetornaItem, ServicoItem, setServicoItem,
        AdicionarAnexo, ListaAnexo, BaixarAnexo, ExcluirAnexo,
        AddFile, setAddFile, File, setFile,
        FormAnexo, setFormAnexo,
        AdicionarAnexoServico, ListaAnexoServico, BaixarAnexoServico, ExcluirAnexoServico,
        AddFileServico, setAddFileServico, FileServico, setFileServico,
        FormAnexoServico, setFormAnexoServico,
        AdicionarLink, ListaLink, ExcluirLink,
        AddLink, setAddLink, FormLink, setFormLink,
        linkRef, descricaoRef, Link, setLink,
        ListaOrganizacaoServico, ServicoOrganizacao, setServicoOrganizacao,
        ListaAreaServico, ServicoArea, setServicoArea,
        ListaPraticaServico, ServicoPratica, setServicoPratica,
        ListaFornecedorServico, ServicoFornecedor, setServicoFornecedor,
        RetornaLocalidade, ServicoLocalidade, setServicoLocalidade,
        ListaLocalidadeServico, ServicoLocalidadeEditar, setServicoLocalidadeEditar,
        AdicionarSistemaServico, ExcluirSistemaServico,
        ListaSistemaServico, ServicoSistema, setServicoSistema,
        ObterServico, ServicoObter, setServicoObter,
        Success, Error, setError, Loading, setLoading,
        openModal, setOpenModal, ListaAreaDisponivel, AreaServicoDisponivel, ListaExecutorServico, ServicoExecutor, 
        filtroGrupo, ListaFiltroGrupo, totalRegistrosFiltroGrupo, totalRegistrosGrupo,
        filtroSubgrupo, ListaFiltroSubgrupo, totalRegistrosFiltroSubgrupo, totalRegistrosSubgrupo,
        filtroItem, ListaFiltroItem, totalRegistrosFiltroItem, totalRegistrosItem,
        filtroSLA, ListaFiltroSLA, totalRegistrosFiltroSLA, totalRegistrosSLA,
        filtroPeriodicidade, ListaFiltroPeriodicidade, totalRegistrosFiltroPeriodicidade, totalRegistrosPeriodicidade,
        filtroTipoServico, ListaFiltroTipoServico, totalRegistrosFiltroTipoServico, totalRegistrosTipoServico,
        filtroMetodo, ListaFiltroMetodo, totalRegistrosFiltroMetodo, totalRegistrosMetodo,
        filtroCobertura, ListaFiltroCobertura, totalRegistrosFiltroCobertura, totalRegistrosCobertura,
        filtroPratica, ListaFiltroPratica, totalRegistrosFiltroPratica, totalRegistrosPratica,
        filtroOrganizacao, ListaFiltroOrganizacao, totalRegistrosFiltroOrganizacao, totalRegistrosOrganizacao,
        filtroLocalidade, ListaFiltroLocalidade, totalRegistrosFiltroLocalidade, totalRegistrosLocalidade,
        filtroFornecedor, ListaFiltroFornecedor, totalRegistrosFiltroFornecedor, totalRegistrosFornecedor,
        filtroServico, ListaFiltroServico, totalRegistrosFiltroServico, totalRegistrosServico,
    }

    return (
        <ServicoContext.Provider value={data}>
            {children}
        </ServicoContext.Provider>
    )
}